export const k = {
    dialogHeader: "domains.application.components.main-layout.components.settings-dialog.settings-dialog-i18n.dialogHeader",
    languageLabel: "domains.application.components.main-layout.components.settings-dialog.settings-dialog-i18n.languageLabel",
    languageDa: "domains.application.components.main-layout.components.settings-dialog.settings-dialog-i18n.languageDa",
    languageEn: "domains.application.components.main-layout.components.settings-dialog.settings-dialog-i18n.languageEn"
};
export const translations = {
    da: { dialogHeader: "Indstillinger", languageLabel: "Sprog", languageDa: "Dansk", languageEn: "Engelsk" },
    en: { dialogHeader: "Settings", languageLabel: "Language", languageDa: "Danish", languageEn: "English" }
};
